import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useResizablePanel } from './useResizablePanel';
import { APPBAR_HEIGHT } from '../layout/TopAppBar';
import type { ResizableHandleProps } from './types';

export function ResizableHandle({ storageKey }: ResizableHandleProps) {
  const { isDragging, handleMouseDown } = useResizablePanel({
    cssVariable: storageKey ? `--${storageKey}-width` : '--panel-width',
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box
      onMouseDown={handleMouseDown}
      sx={{
        width: '4px',
        height: isMobile ? '100vh' : `calc(100vh - ${APPBAR_HEIGHT}px)`,
        position: 'fixed',
        top: isMobile ? 0 : APPBAR_HEIGHT,
        right: storageKey ? `var(--${storageKey}-width)` : 'var(--panel-width)',
        cursor: 'col-resize',
        backgroundColor: theme =>
          isDragging ? theme.palette.primary.main : theme.palette.divider,
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: theme => theme.palette.primary.light,
        },
        zIndex: 101,
        willChange: 'right',
      }}
    />
  );
}
